import React from 'react';
import { Route, Routes } from 'react-router';
import { FundAccountSelectFundingSource } from '@tcs/fund-account/pages/SelectFundingSource';
import { FundAccountDepositForm } from '@tcs/fund-account/pages/Deposit';
import { NextSteps } from '@tcs/fund-account/pages/NextSteps';
import { Header } from '@tcs/client-portal-common/components/organisms/Header';
import TabContent from '@tcs/common/components/atoms/TabContent';

export const Funding = () => {
  return (
    <>
      <Header pageTitle="Fund My Account" />

      <TabContent label="Not shown">
        <Routes>
          <Route path="deposit" element={<FundAccountDepositForm />} />
          <Route path="next-steps" element={<NextSteps />} />
          <Route path="*" element={<FundAccountSelectFundingSource />} />
        </Routes>
      </TabContent>
    </>
  );
};

export default Funding;
